import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { MenuController, NavParams } from 'ionic-angular';
import { AuthService } from '../../services/auth/auth.service';
import { Empresa, EmpresaApi } from '../../services/lbsdk';

/**
 * Generated class for the ComponetsEyesInfoComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'app-header',
  templateUrl: 'header.html'
})
export class HeaderComponent {
  @Output() informarCambioEmpresa = new EventEmitter<Number>();
  @Output() refrescarGrilla = new EventEmitter<Number>();
  info: any;
  //empresaSeleccionada: Empresa;
  empresaSeleccionada: number;
  empresas = []
  constructor(public navParams: NavParams, public menuCtrl: MenuController, private empresaApi: EmpresaApi,
    private authService: AuthService, private cdr: ChangeDetectorRef) {

    console.log("empresa 1 ", this.authService.empresasUsuario)
    if (this.authService.empresasUsuario && !this.authService.isSuperAdministrador()) {

      this.empresaSeleccionada = this.authService.empresasUsuario[0].idEmpresa
      this.authService.empresaSeleccionada = this.authService.empresasUsuario[0].idEmpresa
      console.log("EMPRESA SELECCIONADA ", this.empresaSeleccionada)
      this.cambioEmpresa();

    }
    else if (this.authService.isSuperAdministrador()){
    
      this.empresaSeleccionada = this.authService.empresasUsuario[0].idEmpresa
      this.authService.empresaSeleccionada = this.authService.empresasUsuario[0].idEmpresa
      this.cambioEmpresa();

    }
    // this.empresaApi.find().subscribe(respuesta => {
    //   console.log("empresa 2 ", respuesta)
    //   this.empresas = respuesta;
    //   this.empresaSeleccionada = this.empresas[0]
    //   this.authService.empresaSeleccionada = this.empresas[0]
    // });

    /*  this.empresaApi.find().subscribe(respuesta => {
        this.empresas = respuesta;
  
        if(this.authService.isSuperAdministrador()){
  
          
            this.empresaSeleccionada = this.empresas[0]
            this.authService.empresaSeleccionada = this.empresas[0]
            
          }
          else {
  
            this.filtrarEmpresas();
          }
        })
  */
  }

  recargar(){
    this.refrescarGrilla.emit();
  }
  openMenu() {
    this.menuCtrl.enable(true, 'myMenu');

    this.menuCtrl.open();
  }

  compareWith(o1, o2) {
    try {
      return o1 && o2 ? o1.id === o2.id : o1 === o2;
    } catch (error) {
      return null
    }
  }
  cambioEmpresa() {
   // alert("CAMBIO DE EMPRESA O ES LA MISMA " + JSON.stringify(this.empresaSeleccionada))
    this.authService.empresaSeleccionada = this.empresaSeleccionada
    this.informarCambioEmpresa.emit(this.empresaSeleccionada)

  }
  filtrarEmpresas() {
    console.log("FILTRA EMPRESA ")
    let empresaUsuario = [];
    let idsMongo = this.authService.userData.sucursales.map(res => { return res.idempresa })
    console.log("MONGO ID ", idsMongo)
    this.empresas = this.empresas.filter(item => idsMongo.includes(item.idEmpresa));
    if (this.empresas.length > 0) {
      console.log("SETEA EMPRESA ---------------")
      this.empresaSeleccionada = this.empresas[0]
      this.authService.empresaSeleccionada = this.empresas[0]
      
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/header/header.ts